import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../../web/components-v2/Theme/theme';

const symbolColWidth = 110;
const prizeInputWidth = 150;
const rowHeight = 44;

export const styleSheet = StyleSheet.create({
	container: {
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[24],
	},
	header: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
		marginBottom: SPACE[8],
	},
	prizeColHeader: {
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.xs,
		gap: SPACE[16],
		letterSpacing: '0.04em',
		marginTop: SPACE[8],
		textTransform: 'uppercase',
	},
	prizeColHeaderSymbols: {
		fontWeight: THEME.typography.fontWeights.semibold,
		width: symbolColWidth,
	},
	prizeInput: {
		width: prizeInputWidth,
	},
	row: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[16],
		height: rowHeight,
	},
	symbol: {
		height: 'auto',
		maxHeight: 26,
		width: 'auto',
	},
	symbolCol: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		gap: SPACE[4],
		width: symbolColWidth,
	},
});
